import { css } from '@emotion/react';

export const footerTrash = css`
  flex: 1 1 auto;
  min-width: 0;
`;
